"use client"

import { LazyMotion, domAnimation, m } from 'framer-motion';
import { useTranslations } from 'next-intl';
import React from 'react'
import PrimaryBtn from '../PrimaryBtn';
import ROUTES from '@/lib/routes';
import { useLandingCms } from '@/app/contexts/LandingCmsContext';
import { useLocalizedRoute } from '@/app/lib/useLocalizedRoute';
import { isGccLandingPath } from '@/app/lib/gccLandingPath';
import { usePathname } from 'next/navigation';

const ContactUs = () => {
    const t = useTranslations("ContactUs");
    const cms = useLandingCms();
    const { getLocalizedRoute } = useLocalizedRoute();
    const pathname = usePathname();
    const isGccLandingPage = isGccLandingPath(pathname);

    // Helper function to get translation with fallback
    const getTranslation = (key: string, fallback: string) => {
        const translated = t(key);
        if (
            translated === `ContactUs.${key}` ||
            translated.startsWith("ContactUs.")
        ) {
            return fallback;
        }
        return translated;
    };

    return (
        <LazyMotion features={domAnimation}>
        <section className="relative w-full  flex flex-col items-center justify-center overflow-hidden py-20 pb-40 bg-[#191919]">
            {/* Main Content Container */}
            <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 h-full flex flex-col justify-center">
                {/*Gradient Background*/}
                <m.div
                    initial={{ opacity: 0, y: -20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className='bg-gradient-to-b from-[#000000] to-[#323339] rounded-[25px] py-14 md:py-18 lg:px-0 px-8'>

                    {/* Title Section */}
                    <h2 className="mb-3 sm:mb-4 md:mb-6 max-w-[580px] text-2xl md:text-3xl lg:text-[40px] !leading-8 md:!leading-10 lg:!leading-[55px] text-[#767EF6] text-center mx-auto"
                        style={{
                            fontStyle: "normal",
                            fontWeight: 800
                        }}
                    >
                        {cms?.contactSectionTitle?.trim() ||
                            getTranslation("title", "Your success with PineGen AI matters !")}
                    </h2>


                    {/* Descriptive Text */}
                    <p
                        className="text-center text-[#FCFAFA] max-w-[760px] mb-6 md:mb-8 mx-auto md:text-lg lg:text-2xl"
                        style={{
                            lineHeight: "1.5",
                            fontWeight: "500"
                        }}
                    >
                        {cms?.contactSectionDescription?.trim() ||
                            getTranslation("description", "Whether you have questions about PineGen AI, need support along the way or want to share your feedback, our team is always ready to listen and help you move forward.")}
                    </p>

                    {!isGccLandingPage && (
                        <div className="flex items-center justify-center">
                            <PrimaryBtn
                                translationNamespace="ContactUs"
                                translationKey="contactUs"
                                labelOverride={cms?.contactSectionCtaText?.trim() || undefined}
                                route={getLocalizedRoute(ROUTES.CONTACT)}
                            />
                        </div>
                    )}

                </m.div>
            </div>
        </section>
        </LazyMotion>
    )
}

export default ContactUs